import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorB1 } from "@/services/esus/indicator/esb/b1/getDetailedCitizenAttendancesIndicatorB1";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB1CitizenHistoryItem } from "./IndicatorEsbB1CitizenHistoryItem";
import { IndicatorEsbB1CitizenHistoryInfo } from "./IndicatorEsbB1CitizenHistoryInfo";

type IndicatorEsbB1CitizenHistoryProps = {
	citizenWithDentalAttendances: DetailedCitizenAttendancesIndicatorB1;
};

export function IndicatorEsbB1CitizenHistory({
	citizenWithDentalAttendances,
}: Readonly<IndicatorEsbB1CitizenHistoryProps>) {
	const indicatorEsbB1CitizenHistoryInfo = {
		fullName: citizenWithDentalAttendances.fullName
			? citizenWithDentalAttendances.fullName
			: "N/A",
		birthdate: citizenWithDentalAttendances.birthdate
			? dayjs(citizenWithDentalAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithDentalAttendances.birthdate
			? getAge(dayjs(citizenWithDentalAttendances.birthdate))
			: "",
		document: citizenWithDentalAttendances.cpf
			? formatIdentifier(citizenWithDentalAttendances.cpf)
			: citizenWithDentalAttendances.cns ?? "",
		motherName: citizenWithDentalAttendances.motherName ?? "",
		phone: citizenWithDentalAttendances.phone
			? phoneFormat(citizenWithDentalAttendances.phone)
			: "",
		address:
			addressConcat(
				citizenWithDentalAttendances.street,
				citizenWithDentalAttendances.houseNumber,
				citizenWithDentalAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB1CitizenHistoryInfo {...indicatorEsbB1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atendimentos Odontológicos"
				timeLineContents={(
					citizenWithDentalAttendances.dentalAttendances ?? []
				).map<TimeLineContent>((dentalAttendance) => {
					return {
						content: (
							<IndicatorEsbB1CitizenHistoryItem dentalAttendance={dentalAttendance} />
						),
						eventDate: dentalAttendance.date
							? dayjs(dentalAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
